<template>
  <div class="form-group" :class="{ 'has-error': errors.has(name), 'form-group-active': active }">
    <label class="control-label" v-if="label">{{ label }}</label>
    <multiselect
      :noOptions="messages.noOptions"
      :value="value"
      :options="options"
      :disabled="disabled"
      :group-values="groupValues"
      :group-label="groupLabel"
      :group-select="true"
      :showLabels="false"
      :groupSelect="false"
      :multiple="multiple"
      :placeholder="placeholder"
      track-by="value"
      label="text"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      @blur="changeFocus()"
      @focus="changeFocus()"
    >
      <span slot="noResult">Nenhum registro encontrado.</span>
    </multiselect>
    <error-message :message="errors.first(name)"></error-message>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  inject: ["$validator"],
  name: "form-group-search-select-group",
  components: {
    Multiselect
  },
  props: {
    label: String,
    id: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    required: String,
    value: null,
    options: Array,
    groupValues: {
        type: String,
        default: "options"
    },
    groupLabel: {
        type: String,
        default: "labelGroup"
    },
    multiple: {
        type: Boolean,
        default: false
    }
  },
  data() {
    return {
      active: false,
      messages: {
        noOptions: "Nenhuma opção disponível"
      }
    };
  },
  mounted() {
    this.$el.value = this.value;
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tags {
  border-radius: 3px !important;
  border: 1px solid #ccc !important;
}
.multiselect__option {
  font-size: 13px !important;
}
.multiselect__option--highlight {
  background: rgba(108, 117, 125, 0.1) !important;
  color: #35495e !important;
}
.multiselect__option--selected.multiselect__option--highlight {
  background: rgba(108, 117, 125, 0.1) !important;
  color: #6f859c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupSearchSelectGroup.vue